import { createSlice } from "@reduxjs/toolkit";
import { fetchAllTrainingTypes } from "../thunks/trainingThunks/thunk";


const initialState = {
    loading:false,
    error:null,
    data:{
        trainingTypes:[]
    },
    total:0,
    page:1,
    limit:10
  };
  
  const trainingTypePageSlice = createSlice({
    name: "trainingTypePageSlice",
    initialState,
    reducers: {
      setPage(state, action) {
        state.page = action.payload;
      },
      setLimit(state, action) {
        state.limit = action.payload;
      },
      removeTrainingType(state, action) {
        const { employeeId } = action.payload;  // Get employeeId from the action payload
        state.data.trainingTypes = state.data.trainingTypes.filter(data => data.employeeId !== employeeId);
      }
    },
    extraReducers: (builder) => {
      builder
        
        // Handle fetchAllTrainingTypes
        .addCase(fetchAllTrainingTypes.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchAllTrainingTypes.fulfilled, (state, action) => {
          state.loading = false;
          state.data.trainingTypes = action.payload;
        })
        .addCase(fetchAllTrainingTypes.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
    }
  });
  
  export const { setPage, setLimit,removeTrainingType } = trainingTypePageSlice.actions;
  
  export default trainingTypePageSlice.reducer;